import { accessCodes } from './access-codes';

const parsed = JSON.parse(accessCodes);

// ADMIN: IT group only — full access + upload
export const itAccessIds = parsed
    .filter(a => a.role === 'ADMIN')
    .map(a => a.id);

// USER: all non-admin roles — read access
export const userAccessIds = parsed
    .filter(a => a.role === 'USER')
    .map(a => a.id);

// WAREHOUSE: upload permission (alongside IT)
export const warehouseAccessIds = parsed
    .filter(a => a.name === 'SG-ALL-Warehouse')
    .map(a => a.id);

// Combined: anyone with any access
export const anyAccessIds = parsed.map(a => a.id);

export const hasAccessLevel = (userGroups, accessIds) =>
    userGroups.some(id => accessIds.includes(id));